import * as React from 'react'
import { render } from 'react-dom'
import { unregister } from './serviceWorker'
import App from './components/App'
import './styles.css'

const root = document.getElementById('root')
render(<App />, root)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister()
